export const environment = {
  enablePlayground: true,
  apiUrl: '',
  dboV2ApiUrl: '',
  tmtApiUrl: '',
  version: '1.1.4100-beta',
  environmentName: '',
  healthCheckInterval: '',
  instrumentationKey: '',
  appConfigConnectionString: 'Endpoint=https://triparc-fms-dev-appconfig-fmsservices.azconfig.io;Id=pfat;Secret=Gakq5tBwaNiMO1+7Dyk69hDC2CRGOkAHimhDS4nLxfE=',
  redirectUri:'',
  clientId:'',
  authority:'',
  postLogoutUrl:'https://fms.dev.triparcdev.com/',
  cacheLocation:'',
  graphApiUrl: '',
  fmsApiScope: '',
  graphApiScope:'',
  openAiApiKey: '',
  openAiEndpoint: '',
  openAiDeploymentName: ''
};
